<script>

    import moment from 'moment'
    import Vue from 'vue'
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
    import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
    import FilterBar from './Filter.vue'

    Vue.component('filter-bar', FilterBar);

    export default {

        components: {
            Vuetable,
            VuetablePagination,
            VuetablePaginationInfo
        },

        props: {
            classe: {
                type: String,
                default: 'table table-striped'
            },
            apiUrl: {
                type: String,
                required: true
            },
            rowClass: {
                default: 'onRowClass'
            },
            classFilterColumn: {
                type: String,
                default: 'idColuna'
            },
            fields: {
                type: Array,
                required: true
            },
            sortOrder: {
                type: Array,
                default() {
                    return []
                }
            },
            filtroSelect: {
                type: Array,
                default() {
                    return []
                }
            },
            appendParams: {
                type: Object,
                default() {
                    return {}
                }
            },
            detailRowComponent: {
                type: String
            },
            filtro: {
                type: Boolean,
                default: true

            },
            selectRow: {
                type: Boolean,
                default: false

            },
            perPage: {
                default: 10
            }
        },

        data () {
            return {
                selectFilter: this.filtroSelect,
                loaderTable: true,
                loadFilter: this.filtro,
                NumberPerPage: this.perPage,
                ViewNumberPerPage: this.selectRow,
                DatarowClass: this.rowClass,
                moreParams: this.appendParams,
                css: {
                    tableClass: this.classe,
                    loadingClass: 'loading',
                    handleIcon: 'glyphicon glyphicon-menu-hamburger',
                    pagination: {
                        infoClass: 'pull-left',
                        wrapperClass: 'vuetable-pagination pull-right',
                        activeClass: 'item-active',
                        disabledClass: 'disabled',
                        pageClass: 'item',
                        linkClass: 'item',
                        icons: {
                            first: 'fa fa-angle-double-left',
                            prev: 'fa fa-angle-left',
                            next: 'fa fa-angle-right',
                            last: 'fa fa-angle-double-right',
                        },
                    },
                    table: {
                        tableClass: this.classe,
                        ascendingIcon: 'fa fa-arrow-up',
                        descendingIcon: 'fa fa-arrow-down'
                    },
                    translate: {
                        noDataTemplate: 'Nenhum registro encontrado.',
                        paginationInfoTemplate: 'Showing: {from} - {to} out of {total} records'
                    },
                }
            }
        },

        mounted () {
            var $this = this;
            this.$events.off('filter-set-' + $this.classFilterColumn);
            this.$events.off('filter-reset-' + $this.classFilterColumn);
            this.$events.off('per-page-' + $this.classFilterColumn);

            this.$events.$on('filter-set-' + $this.classFilterColumn, eventData => this.onFilterSet(eventData));
            this.$events.$on('filter-reset-' + $this.classFilterColumn, e => this.onFilterReset());
            this.$events.$on('per-page-' + $this.classFilterColumn, eventData => this.onPerPage(eventData))
        },

        updated () {

            var $this = this;
//            $this.moreParams = {};
            this.$events.off('filter-set-' + $this.classFilterColumn);
            this.$events.off('filter-reset-' + $this.classFilterColumn);
            this.$events.off('per-page-' + $this.classFilterColumn);

            this.$events.$on('filter-set-' + $this.classFilterColumn, eventData => this.onFilterSet(eventData));
            this.$events.$on('filter-reset-' + $this.classFilterColumn, e => this.onFilterReset());
            this.$events.$on('per-page-' + $this.classFilterColumn, eventData => this.onPerPage(eventData))
        },

        render(h) {
            return h(
                'div',
                {
                    class: { ui: true, container: false }
                },
                [

                    this.renderLoader(h),
                    this.renderFiler(h),
                    this.renderVuetable(h),
                    this.renderPagination(h)
                ]
            )
        },

        methods: {

            concateFormat(v, c, t = 1) {
                if (v == null) {
                    return '';
                }

                if (t == 2) {
                    return v + ' ' + c;
                }

                return  c + ' ' + v
            },

            renderLoader(h) {

                if (this.loaderTable == true) {

                    return h(
                        'loader'
                    )

                } else {

                    return h('')
                }

            },

            renderFiler(h) {

                if(this.loadFilter == true) {

                    return h(
                        'filter-bar',
                        {
                            ref: 'filterbar',
                            props: {
                                fields: this.fields,
                                classFilterColumn: this.classFilterColumn,
                                perPage: this.NumberPerPage,
                                selectRow: this.ViewNumberPerPage,
                                filtroSelect: this.selectFilter
                            }
                        }
                    )
                } else {
                    return h('')
                }
            },

            renderVuetable(h) {

                return h(
                    'vuetable',
                    {
                        ref: 'vuetable',
                        props: {
                            apiUrl: this.apiUrl,
                            httpOptions: { headers: { Authorization: 'Bearer ' + localStorage.getItem('token') } },
                            fields: this.fields,
                            css: this.css.table,
                            noDataTemplate: this.css.translate.noDataTemplate,
                            paginationPath: "",
                            perPage: this.NumberPerPage,
                            multiSort: true,
                            sortOrder: this.sortOrder,
                            appendParams: this.moreParams,
                            detailRowComponent: this.detailRowComponent,
                            rowClass: this.DatarowClass
                        },

                        on: {
                            'vuetable:cell-clicked': this.onCellClicked,
                            'vuetable:pagination-data': this.onPaginationData,
                            'vuetable:loaded': this.onTooltip,
                            'vuetable:row-dblclicked': this.dblclick,
                            'vuetable:row-clicked': this.rowClicked
                        },
                        scopedSlots: this.$vnode.data.scopedSlots
                    }
                )
            },

            renderPagination(h) {
                return h(
                    'div',
                    { class: {'vuetable-pagination': true, 'ui': true, 'basic': true, 'segment': true, 'grid': true} },
                    [
                        h('vuetable-pagination-info', {
                            ref: 'paginationInfo',
                            props: {
                                infoTemplate: "Exibindo {from} a {to} de {total} registros.",
                                noDataTemplate: ''
                            }
                        }),
                        h('vuetable-pagination', {
                            ref: 'pagination',
                            props: {
                                css: this.css.pagination
                            },
                            on: {
                                'vuetable-pagination:change-page': this.onChangePage
                            }
                        })
                    ]
                )
            },

            allcap (value) {
                return value.toUpperCase()
            },

            onPaginationData (paginationData) {
                var $this = this;
                var data = {};
                data.tabela =  $this.classFilterColumn;
                data.valor =  paginationData.total;

                this.$events.fire('total-tabela', data)

                this.$refs.pagination.setPaginationData(paginationData)
                this.$refs.paginationInfo.setPaginationData(paginationData)
            },

            onChangePage (page) {
                this.$refs.vuetable.changePage(page)
            },

            onCellClicked (data, field, event) {

                this.$refs.vuetable.toggleDetailRow(data.id)
            },

            onFilterSet (filterText) {

                var modulo = (filterText.modulo) ? filterText.modulo : 'geral';

                if(filterText.filtertext) {
                    filterText.filtertext = filterText.filtertext.trim()
                }

                if(modulo == 'geral') {
                    if (filterText.optionfilter.length == 0) {
                        return this.$toastr('warning', 'Selecione uma coluna para realizar o filtro!', 'Atenção');
                    }

                    if(filterText.filtertext == '' || filterText.filtertext == null) {
                        return this.$toastr('warning', 'Informe um valor a ser filtrado!', 'Atenção');
                    }

                    this.moreParams.filter = filterText.filtertext;
                    this.moreParams.optionsFilter = filterText.optionfilter;

                } else {

                    this.moreParams = filterText.optionfilter;
                }

                Vue.nextTick(() => this.$refs.vuetable.refresh())
            },

            onFilterReset () {

                this.moreParams = {};

                Vue.nextTick( () => this.$refs.vuetable.refresh() )
            },

            onPerPage (filterText) {

                this.moreParams.filter = filterText.filtertext;
                this.moreParams.optionsFilter = filterText.optionfilter;
                this.NumberPerPage = parseInt(filterText.val);

                Vue.nextTick( () => this.$refs.vuetable.refresh() )
            },

            onTooltip: function () {
                this.loaderTable = false;
                $('[data-toggle="tooltip"]').tooltip();
            },

            dblclick: function (data, field, event) {

                var $this = this;
                this.$events.fire('dblclick-' +  $this.classFilterColumn, data)
            },

            formatType (value) {

                if(value == 1 || value == '1') {

                    return 'Visita';
                }

                return 'Abordagem';

            },

            formataCampos (valor) {

                if(valor == null || valor == '') {
                    return ''
                }

                valor =  valor.replace('{', '').replace('}', '').split(',"');
                var conteudo = '';

                for(var v = 0; v < valor.length; v++) {
                    conteudo += valor[v].replace('"', '').replace('"', '') + '<br>';
                }

                return conteudo;

            },

            formtBoolean (value) {

                if(value == true) {

                    return 'SIM';
                }

                return 'NÃO';

            },

            formatReal (value) {

                return this.$utils.numberToReal(value);

            },

            formatDate (value, fmt = 'D MMM YYYY') {

                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },

            formatStatusSolicitacao (value) {

                if(value == 1) {
                    return 'Solicitado';
                }

                if(value == 2) {
                    return 'Em processamento';
                }

                if(value == 3) {
                    return 'Enviado';
                }

                if(value == 4) {
                    return 'Recebido';
                }

            },

            checkStatusProposta: function (value) {

                if(value == 1) {
                    return 'Simulação'
                }

                if(value == 2) {
                    return 'Análise Cadastro'
                }

                if(value == 3) {
                    return 'Análise Cadastro'
                }

                if(value >= 4 && value <= 7) {
                    return 'Análise de Crédito'
                }

                if(value == 13 || value == 14 || value == 17) {
                    return 'Análise de Crédito'
                }

                if(value == 10) {
                    return 'Aprovada'
                }

                if(value == 12) {
                    return 'Contratada'
                }

            },

            formatStatus (value) {

                if(value == null ) {
                    return  '<span class="label label-default">PENDÊNCIA</span>';
                }

                var nome = value.split('|')[0].trim();
                var classe = value.split('|')[1].trim();

                return  '<span class="' + classe +'">' + nome + '</span>';

            },

            rowClicked: function (data, field, event) {
                var $this = this;
                this.$events.fire('rowClicked', data)
            },

            checkAtivo(value) {

                if(value == false) {


                    return '<span class="badge badge-danger">Inativo</span>';
                }

                return '<span class="badge badge-success">Ativo</span>';

            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/tables/Table.vue